import { CardTitle } from '@core/cards/common';
import { classes } from '@core/cards/ProductCard/getProductCardCss';

import CardBody from './card/CardBody';
import CardContent from './card/CardContent';
import CardFooter from './card/CardFooter';
import CardHeader from './card/CardHeader';
import CardPartnerInfo from './card/CardPartnerInfo';
import CardPreviewGrid from './card/CardPreviewGrid';
import type { ProductCardProps } from './types';

type Props = {
  'aria-label': string;
  titleId: string;
  partnerInfoId?: string;
} & ProductCardProps;

/**
 * Grid variant of the ProductCard
 */
const ProductGridCard = (props: Props) => {
  const {
    previewImageSrc,
    renderPreviewImage,
    statusTags,
    partners,
    title,
    experimentVariant,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    body,
    footer,
    titleId,
    partnerInfoId,
  } = props;

  const shouldShowPreview = previewImageSrc || renderPreviewImage || statusTags;
  const isTest1 = experimentVariant === 'test1';

  const bodySlot = body ? <CardBody>{body}</CardBody> : undefined;
  const headerSlot = (
    <CardHeader>
      {partners && <CardPartnerInfo id={partnerInfoId} partners={partners} />}
      {title && (
        <CardTitle
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledby}
          component={title?.component}
          customLinkProps={title.customLinkProps}
          id={titleId}
          linkProps={title.linkProps}
          name={title.name}
        />
      )}
    </CardHeader>
  );

  const headerBodySlot = isTest1 ? (
    <div className={classes.headerBodySlot}>
      {headerSlot}
      {bodySlot}
    </div>
  ) : null;

  return (
    <div className={classes.gridCard}>
      {shouldShowPreview && (
        <CardPreviewGrid
          imageSrc={previewImageSrc}
          renderImage={renderPreviewImage}
          statusTags={statusTags}
        />
      )}
      <CardContent>
        {isTest1 ? (
          headerBodySlot
        ) : (
          <>
            {headerSlot}
            {bodySlot}
          </>
        )}
        {footer && <CardFooter>{footer}</CardFooter>}
      </CardContent>
    </div>
  );
};

export default ProductGridCard;
